export default __webpack_public_path__ + "static/media/roadmapBgMb.76a88d0d.png";